// @flow
import config from '../../config';
import { buildQueryParams } from './search-shipments-kpis-request';
import { createApiCall } from './api-factory';

const BASE_URL = config.ZONES_ANALYTICS_URL;

const makeApiCall = createApiCall(BASE_URL, buildQueryParams);

function getAvgDomesticZone(query): any {
    const endpoint = '/average_domestic_zone';
    return makeApiCall(endpoint, query);
}

function getZonesCount(query): any {
    const endpoint = '/zones_count';
    return makeApiCall(endpoint, query);
}

function getDomesticZonesByTimeframe(query): any {
    const endpoint = '/zones_by_timeframe';
    return makeApiCall(endpoint, query);
}

function getZonesShipmentsCost(query): any {
    const endpoint = '/zones_shipments_cost';
    return makeApiCall(endpoint, query);
}

export {
    getAvgDomesticZone,
    getZonesCount,
    getDomesticZonesByTimeframe,
    getZonesShipmentsCost,
};
